export default "__VITE_ASSET__D6KftqY0__"